<template>
    <div>
        <b-navbar toggleable="lg" class="main-color-background">
            <v-btn outlined @click="drawer = !drawer" :disabled="!signedIn">
                <v-icon>mdi-menu</v-icon>
            </v-btn>
            <b-container fluid class="navLinkBrand">
                <b-navbar-brand to="/"><b>Syncware</b></b-navbar-brand>
            </b-container>
            <v-spacer/>
            <v-btn @click="goToInfoPage" color="black" icon :disabled="!signedIn">
                <v-icon>mdi-information-outline</v-icon>
            </v-btn>
        </b-navbar>

        <v-navigation-drawer v-model="drawer" fixed temporary v-if="signedIn">
            <template v-slot:prepend>
                <v-list shaped nav>
                    <v-list-item to="/account" @click="active = '/account'"
                                 v-bind:active="active === '/account'" shaped class="navLink">
                        <v-list-item-title class="navAccountLink">
                            <v-icon :color="sitionColor">mdi-account-circle</v-icon>
                            <span v-if="accountInfo.lastname == null">account</span>
                            <span v-else class="navAccountLinkText"> {{accountInfo.firstname + " " +accountInfo.lastname}}</span>
                        </v-list-item-title>
                    </v-list-item>
                </v-list>
                <v-divider class="navDivider"/>
            </template>
            <v-list dense shaped nav>
                <v-list-item
                        v-for="item in navBarItems"
                        v-if="roles.some(role => item.roles.includes(role))"
                        :key="item.path"
                        :to="item.path"
                        v-bind:active="active === item.path"
                        @click="active = item.path"
                        class="navLink">
                    <v-list-item-title>{{ item.name }}</v-list-item-title>
                </v-list-item>
            </v-list>

            <template v-slot:append>
                <v-divider class="navDivider"/>
                <v-list dense shaped nav>
                    <v-list-item
                            class="navLink">
                        <v-list-item-subtitle>
                            Signed in until {{new Date(signInExpiresAt).toLocaleTimeString()}}
                        </v-list-item-subtitle>
                    </v-list-item>
                    <v-list-item
                            key="/sign-out"
                            @click="logout()"
                            class="navLink">
                        <v-list-item-title>
                            <v-icon>mdi-exit-to-app</v-icon>
                            Logout
                        </v-list-item-title>
                    </v-list-item>
                </v-list>
                <v-spacer class="navFooterOffset"/>
            </template>
        </v-navigation-drawer>
    </div>
</template>

<script>
    import AccountRepository from '../repositories/account.repository';

    export default {
        data() {
            return {
                drawer: false,
                signedIn: false,
                signInExpiresAt: 0,
                roles: ['ROLE_USER'],
                accountInfo: {},
                active: '/',
                navBarItems: [
                    {path: '/dashboard', name: 'Dashboard', roles: ['ROLE_ADMIN', 'ROLE_DEVELOPER', 'ROLE_USER']},
                    {path: '/users', name: 'Users', roles: ['ROLE_ADMIN']},
                    {path: '/projects', name: 'Projects', roles: ['ROLE_ADMIN']},
                    {path: '/events', name: 'Events', roles: ['ROLE_ADMIN', 'ROLE_DEVELOPER']},
                    {path: '/webhooks', name: 'Webhooks', roles: ['ROLE_ADMIN', 'ROLE_DEVELOPER']},
                    {path: '/cron_subscribers', name: 'Cron subscribers', roles: ['ROLE_ADMIN', 'ROLE_DEVELOPER']},
                    {path: '/subscribers', name: 'Subscribers', roles: ['ROLE_ADMIN', 'ROLE_DEVELOPER']},
                    {path: '/logs', name: 'Logs', roles: ['ROLE_ADMIN', 'ROLE_DEVELOPER']},
                    {path: '/tasks', name: 'Tasks', roles: ['ROLE_ADMIN', 'ROLE_DEVELOPER', 'ROLE_USER']},
                    {path: '/calls', name: 'Calls', roles: ['ROLE_ADMIN', 'ROLE_DEVELOPER', 'ROLE_USER']},
                ]
            }
        },
        created() {
            this.redrawNav();

            let parts = window.location.href.split('/');
            let current = parts[parts.length - 1];
            this.active = `/${current}`;
        },
        methods: {
            redrawNav: function () {
                if (new Date().getTime() >= new Date(Date.parse(localStorage.getItem('signInExpiresAt'))).getTime()) {
                    this.$router.push({
                        name: 'automatic_sign-out',
                        params: {'currentroute': this.$route.currentRoute}
                    });
                }
                if (localStorage.getItem('signedIn') === 'true') {
                    this.signedIn = true;
                    AccountRepository.getUserInfo().then(res => {
                        this.roles = res.data.role;
                        this.accountInfo = res.data;
                    }).catch(error => {
                        console.error(error);
                    });
                    this.signInExpiresAt = Date.parse(localStorage.getItem('signInExpiresAt'));
                } else if (this.signedIn) {
                    this.signedIn = false;
                    this.signInExpiresAt = 0;
                }
            },
            goToInfoPage: function () {
                this.$router.push({name: 'info'});
            },
            logout() {
                this.active = '/';
                let currentRoute = this.$router.currentRoute;
                this.$router.push({
                    name: 'sign-out',
                    params: {'currentroute': currentRoute}
                });
            }
        }
    }
</script>

<style>

    .navDivider {
        margin: 0;
    }

    .navFooterOffset {
        height: 34px;
    }

    .navLink {
        text-decoration: none !important;
    }

    .navLinkBrand {
        width: 0;
        padding-left: 10px !important;
    }

    .navAccountLink {
        display: flex;
        align-items: center;
    }

    .navAccountLinkText {
        padding-left: 5px;
    }

</style>
